import axios from 'axios';

// Define module-level variables for base_url and language
let BASE_URL = '';
let LANGUAGE = '';

// Function to update the base_url
export const setBaseUrl = (url) => {
  BASE_URL = url;
};

// Function to update the language
export const setLanguage = (lang) => {
  LANGUAGE = lang;
};

// Centralized function to make API calls
const makeApiCall = async (endpoint, settings, useCache = true) => {
  // Construct the API URL using the base_url and language
  const API_URL = `${BASE_URL}/${LANGUAGE}/${endpoint}`;

  // Create a cache key based on the endpoint, method, params and data
  // Check if the response is already in the cache and if useCache is true
  const cacheKey = `${endpoint}_${JSON.stringify(settings)}`;
  if (useCache && localStorage.getItem(cacheKey)) {
    return JSON.parse(localStorage.getItem(cacheKey));
  }

  try {
    const response = await axios({
      url: API_URL,
      headers: {
        'Accept-Language': LANGUAGE,
        'Content-Type': 'application/json',
      },
      ...settings,
    });

    // Store the response in the cache if useCache is true
    if (useCache) {
      localStorage.setItem(cacheKey, JSON.stringify(response.data));
    }

    return response.data;
  } catch (error) {
    console.error(`makeApiCall ${endpoint}`, error.message);
    return null;
  }
};

export const fetchCategories = async (search) => {
  const response = await makeApiCall(`api/faq/categorie${search ? `?search=${search}` : ''}`, {
    method: 'get'
  }, false);

  if (!response) {
    console.error('fetchCategories', response, !search);
    return [];
  }
  return response;
};

export const fetchQuestions = async (search) => {
  const response = await makeApiCall(`api/faq/domande${search ? `?search=${search}` : ''}`, {
    method: 'get'
  }, false);

  if (!response) {
    console.error('fetchQuestions', response, !search);
    return [];
  }
  return response;
};

export const sendContactForm = async (data) => {
  const response = await makeApiCall('api/faq/contatti', {
    method: 'post',
    data
  });

  if (!response) {
    console.error('sendContactForm', response);
    return false;
  }
  return true;
}